import { render, staticRenderFns } from "./FriendIndex.vue?vue&type=template&id=7dc0ee3a&scoped=true&"
import script from "./FriendIndex.vue?vue&type=script&lang=js&"
export * from "./FriendIndex.vue?vue&type=script&lang=js&"
import style0 from "./FriendIndex.vue?vue&type=style&index=0&id=7dc0ee3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc0ee3a",
  null
  
)

export default component.exports